<div class="dashboard-floors">
  <coa-dashboard-floors-header
    class="dashboard-floors-header">
  </coa-dashboard-floors-header>

  <coa-dashboard-floors-body
    [categoryId]="categoryId"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-floors-body">
  </coa-dashboard-floors-body>
</div>

